"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.isSkipped = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.getDataConnectorsValues = exports.getDataConnectors = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var fields = exports.fields = ['question', 'description', 'labelsVerticalPosition', 'min', 'max', 'defaultValue', 'snapToLabels', 'isAnswerRequired', 'noAnswerMessage', 'maxWidth', 'showNumberWhenDragging', 'labels[].id', 'labels[].value', 'labels[].name', 'labels[].position', 'labels[].verticalPosition', 'isLabelsExpanded', 'isLimitsExpanded', 'isValidationExpanded', 'isOthersExpanded'];
var ttsFields = exports.ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings,
    isMatrixMode = _ref.isMatrixMode;
  var result = isMatrixMode ? [] : ['question', 'description'];
  result.push.apply(result, _toConsumableArray(settings.labels.map(function (item, index) {
    return "labels[".concat(index, "].name");
  })));
  return result;
};
var initialValues = exports.initialValues = {
  question: '<p><strong>What is your opinion about ...?</strong></p>',
  isLimitsExpanded: true,
  isLabelsExpanded: true,
  isOthersExpanded: false,
  labels: [{
    id: 1,
    value: '0',
    name: 'Min',
    position: 'left',
    verticalPosition: 'bottom'
  }, {
    id: 2,
    value: '5',
    name: 'Middle',
    position: 'center',
    verticalPosition: 'bottom'
  }, {
    id: 3,
    value: '10',
    name: 'Max',
    position: 'right',
    verticalPosition: 'bottom'
  }],
  min: '0',
  max: '10',
  maxWidth: '500px',
  showNumberWhenDragging: false,
  defaultValue: '5',
  snapToLabels: false,
  noAnswerMessage: 'An answer is required.'
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-download-alt"
});
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (values.min && !(0, _isInt["default"])(values.min.toString(), {
    min: 0,
    max: 10000
  })) {
    errors.min = 'Value should be a whole number 0 to 10000';
  }
  if (values.max && !(0, _isInt["default"])(values.max.toString(), {
    min: 0,
    max: 10000
  })) {
    errors.max = 'Value should be a whole number 0 to 10000';
  }
  if (values.min !== undefined && values.max !== undefined && !errors.min && !errors.max) {
    if (+values.min > +values.max) {
      errors.max = 'Max should be more than min';
    }
    if (values.defaultValue && !(0, _isInt["default"])(values.defaultValue.toString(), {
      min: +values.min,
      max: +values.max
    })) {
      errors.defaultValue = "Value should be a whole number ".concat(values.min, " to ").concat(values.max);
    }
  }
  if (values.min !== undefined && values.max !== undefined && !errors.min && !errors.max) {
    if (values.labels) {
      (0, _forEach2["default"])(values.labels, function (label, index) {
        if (!(0, _isInt["default"])(label.value.toString(), {
          min: +values.min,
          max: +values.max
        })) {
          errors.labels = errors.labels || [];
          errors.labels[index] = errors.labels[index] || {};
          errors.labels[index].value = "Value should be a whole number ".concat(values.min, " to ").concat(values.max);
        }
      });
    }
  }
  return errors;
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'sl';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  var question = settings.question,
    min = settings.min,
    max = settings.max;
  var metricsPrefix = getMetricsPrefix();
  var data = {
    title: (0, _cccisdSurveyCommon.stripTags)(question),
    titleHtml: question,
    type: 'number',
    questionType: 'slider',
    variableType: 'answer',
    tags: {
      system: ['answer']
    },
    minimum: +min,
    maximum: +max
  };
  return _defineProperty({}, id + '_answer', _objectSpread(_objectSpread({}, data), {}, {
    reportHeader: "".concat(metricsPrefix, "_").concat(id, "_answer")
  }));
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  if (answer === undefined) {
    return _defineProperty({}, id + '_answer', null);
  }
  return _defineProperty({}, id + '_answer', answer);
};
var getDataConnectors = exports.getDataConnectors = function getDataConnectors(settings) {
  var connectors = {
    number: {
      type: 'number',
      title: 'Result'
    }
  };
  return connectors;
};
var getDataConnectorsValues = exports.getDataConnectorsValues = function getDataConnectorsValues(settings, answer) {
  return {
    number: function number() {
      return Number(answer) || 0;
    }
  };
};
var isSkipped = exports.isSkipped = function isSkipped(_ref5) {
  var settings = _ref5.settings,
    answer = _ref5.answer;
  return typeof answer === 'undefined' || answer === '';
};